export default __webpack_public_path__ + "static/media/saesa-error.1c5ab336.svg";